import React, { memo, useEffect, useContext } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CopilotContext } from '@Sage/ssm-web5';

import { ConfigActions } from 'actions';
import TabLoader from 'containers/TabLoader';

const mapDispatchToProps = (dispatch) => {
    return {
        logout: bindActionCreators(ConfigActions, dispatch).logout,
    };
};

const Logout = ({ logout }) => {
    const { clearChat } = useContext(CopilotContext);

    useEffect(() => {
        logout();
        clearChat();
    }, [logout, clearChat]);

    return <TabLoader />;
};

export default memo(connect(null, mapDispatchToProps)(Logout));
